import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryRepoArgs, Repo } from "types/generated";

export const GET_SPACELIFT_VCS_REPO: TypedDocumentNode<{ repo: Repo }, QueryRepoArgs> = gql`
  query GetSpaceliftVcsRepo($id: ID!) {
    repo(id: $id) {
      id
      name
      slug
      description
      isDefault
      createdAt
      updatedAt
      labels
      stacks
      commits(first: 1) {
        edges {
          node {
            sha
          }
        }
      }
      space {
        id
        name
      }
    }
  }
`;
